<template>
  <div :id="anchor" class="text-left" ref="anchorRef">
    <div
      class="accordion-title flex justify-between cursor-pointer py-3 border-b"
      :data-test="dataTestTitle(title)"
      :class="[`border-${borderColour}`, styles.base]"
      @click="onClick">
      <div :class="styles.title">
        {{ title }}
      </div>
      <span class="flex-end self-center">
        <arrow-wide
          class="self-center mr-4"
          :color-class="chevronColour"
          :class="open ? 'transition transform rotate-0' : 'transition transform rotate-180'" />
      </span>
    </div>
    <transition name="slide-fade">
      <div
        class="accordion-content transition slide-in py-3"
        :data-test="dataTestTitle(title) + '-hidden-content'"
        :class="styles.content"
        v-show="open"
        v-html="content" />
    </transition>
  </div>
</template>

<script lang="ts" setup>
import ArrowWide from '@/components/icons/ArrowWide.vue'
import { nextTick, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useScrollToElementBelowHeader } from '@/composables/useScrollTo.ts'

const getHeaderHeight = () => {
  const header = document.querySelector('header.sticky')
  return header ? header.clientHeight : 0
}

const { scrollTo } = useScrollToElementBelowHeader(getHeaderHeight)

const anchorRef = ref<HTMLElement | null>(null)
const router = useRouter()
const route = useRoute()
type AccordionStyle = {
  title: string
  content: string
  base: string
}

interface Props {
  id: string
  title: string
  anchor: string
  content: string
  borderColour?: string
  chevronColour?: string
  styles?: AccordionStyle
}

const props = withDefaults(defineProps<Props>(), {
  id: 'accordion-id',
  title: 'Accordion Title',
  content: 'Content goes here',
  borderColour: 'grey-2',
  chevronColour: '#888',
  styles: () => {
    return {
      title: 'text-16px',
      content: '',
      base: '',
    }
  },
})

onMounted(async () => {
  if (route.hash && route.hash == '#' + props.anchor) {
    open.value = !open.value
  }
  if (route.hash) {
    const el = anchorRef.value
    if (route.hash && route.hash == '#' + props.anchor) {
      open.value = true
      if (el) {
        await scrollTo(el)
        console.log('boom')
      }
    }
  }
})

const open = ref(false)

const dataTestTitle = (title: string) => {
  return title.replace(/\s+/g, '-')
}

const onClick = async () => {
  open.value = !open.value

  if (props.anchor && open.value) {
    // router.push({ name: route.name?.toString(), hash: '#' + props.anchor })
    const el = anchorRef.value
    if (el) {
      await scrollTo(el)
    }
  } else {
    history.replaceState('', '', location.pathname)
  }
}
</script>

<style  scoped>
.slide-fade-enter-active {
  animation: anim-slide-fade 0.5 ease-in;
}

.slide-fade-leave-active {
  animation: anim-slide-fade 0.5 reverse;
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateY(-20px);
  opacity: 0;
}

@keyframes anim-slide-fade {
  0% {
    opacity: 0;
    transform: translateY(-20%);
  }

  20% {
    opacity: 0;
  }

  50% {
    opacity: 1;
    transform: translateY(0%);
  }

  100% {
    opacity: 1;
    transform: translateY(0%);
  }
}

:deep(ul) {
  list-style: disc;
  margin-left: 20px;
}
</style>
